import React from 'react'
import {createIcon} from '@chakra-ui/icons'

export const EditIcon = createIcon({
    displayName: 'EditIcon',
    viewBox: '0 0 22 20', // Update the viewBox to match the new SVG
    path: (
        <path
            d="M11 19H21M13.856 1L7.006 7.854L1 13.858V18.999H6.142L12.149 12.995L19 6.145L13.856 1Z"
            stroke="#25252B"
            strokeLinecap="square"
            fill="none"
        />
    )
})
